import { ApolloError } from '@apollo/client'
import { Option } from '@joor/design-system'

import {
  PriceTypesQueryCAQuery,
  ShippingBillingQueryCAQuery,
} from '__generated__/atlas-types'

export enum OrderStatus {
  CANCELLED = 'CANCELLED',
  IN_PROGRESS = 'IN_PROGRESS',
  RETURNED = 'RETURNED',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  SHIPPED = 'SHIPPED',
  NOTES = 'NOTES',
  ALL_NOTES = 'ALL_NOTES',
  NOTES_WITH_QUANTITIES = 'NOTES_WITH_QUANTITIES',
  NOTES_WITHOUT_QUANTITIES = 'NOTES_WITHOUT_QUANTITIES',
}

export type DropdownOption = {
  text: string
  key: string
  value: string
  className?: string
}

// Represents a customer: Connected Account | Customer Record
export type Customer = {
  id?: string
  displayName?: string
  brandDoorMatches: any[]
  brandWarehouseMatches?: any[]
  priceTypeMatches: any[]
  locations: any[]
  // Only exists if the customer represents a Customer Record
  retailerId?: string
}

export type Linesheet = {
  id: string
  code?: string
  name: string
}

export type BillingAddress = {
  code?: string | null | undefined
  id: string
  phoneNumber?: string
  address?: { companyName?: string | null; city?: string | null } | null
}

export type ShippingAddress = {
  id: string
  code?: string | null
  phoneNumber?: string | null
  address?: { companyName?: string | null; city?: string | null } | null
}

export type PaymentMethod = {
  isDefault?: boolean | null
  paymentMethod?: { id: string; name: string; code: string } | null
}

export type ShippingMethod = {
  shippingMethod: {
    name: string
    code: string
    id: string
  }
}

export type PriceType = {
  id: string
  name: string
  currency: {
    code: string
  }
}

export type ShippingBilling = {
  shippingAddresses: ShippingAddress[]
  shippingMethods: ShippingMethod[]
  billingAddresses: BillingAddress[]
  paymentMethods: PaymentMethod[]
  retailerLocationOption?: Option
}

export type LinesheetsQuery = {
  linesheets: Linesheet[]
  linesheetsQueryLoading: boolean
}

export type ShippingBillingQuery = ShippingBilling & {
  shippingBillingQueryLoading: boolean
}

export type PriceTypesQuery = {
  priceTypes: PriceType[]
  priceTypeQueryLoading: boolean
}

type ApolloErrorLoadingParams = {
  error: ApolloError | undefined
  loading: boolean
}

export type PriceTypesCAParams = ApolloErrorLoadingParams & {
  data: PriceTypesQueryCAQuery | undefined
}

export type ShippingBillingCAParams = ApolloErrorLoadingParams & {
  data: ShippingBillingQueryCAQuery | undefined
}
